import { cn } from '@/lib/cn';

export const fieldLabelClass = 'block text-sm text-secondary';
export const fieldHintClass = 'text-xs text-muted';
export const fieldErrorClass = 'text-sm text-red-400';

export const inputBaseClass =
  'input-field w-full rounded-lg border px-4 py-2.5 text-sm outline-none transition-colors';

export const inputNormalClass =
  'border-[var(--border-visible)] bg-[var(--bg-input)] text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:border-[var(--accent)] disabled:cursor-not-allowed disabled:opacity-60';

export const inputErrorClass = 'border-red-500 focus:border-red-500';

export function fieldInputClass(hasError?: boolean, className?: string) {
  return cn(inputBaseClass, hasError ? inputErrorClass : inputNormalClass, className);
}

export function slugifyLabel(label: string): string {
  return label.toLowerCase().replace(/\s+/g, '-');
}
